import React from "react";
import {ASSETS_CDN, CHAIN} from "../../constants";

/** Commenting out for potential of Essential Chain making a comeback
    const essentialCurve  = `${ ASSETS_CDN }/essential-chain.png`;
    const essentialStraight  = `${ ASSETS_CDN }/essential-chain-straight.png`;
    const essentialPendant  = `${ ASSETS_CDN }/essential-chain-pendant--v2.png`;
**/
const cableCurve  = `${ ASSETS_CDN }/cable-chain-v8.png`;
const cableStraight  = `${ ASSETS_CDN }/cable-chain-straight-v3.png`;
const cablePendant  = `${ ASSETS_CDN }/cable-chain-pendant-v2.png`;
// const beadCurve  = `${ ASSETS_CDN }/bead-chain.png`;
// const beadStraight  = `${ ASSETS_CDN }/bead-chain-straight.png`;
// const beadPendant  = `${ ASSETS_CDN }/bead-chain-pendant--v2.png`;
const butchCurve  = `${ ASSETS_CDN }/butch-chain.png`;
const butchStraight  = `${ ASSETS_CDN }/butch-chain-straight.png`;
const butchPendant  = `${ ASSETS_CDN }/butch-chain-pendant--v2.png`;
const loop  = `${ ASSETS_CDN }/loop.png`;

export const CurvedChain = ({chain, left = false}) => {
    let style = {};
    let chainImage;

    if (left) {
        style.transform = 'scaleX(-1)';
    }

    switch (chain) {
        case CHAIN.CABLE: chainImage = cableCurve; break;
        // case CHAIN.BEAD: chainImage = beadCurve; break;
        case CHAIN.BUTCH: chainImage = butchCurve; break;
    }

    return (
        <img className={`customizer-preview__chain ${chain.description.toLowerCase().replace(' ', '-')} ${left ? 'customizer-preview__chain--left' : 'customizer-preview__chain--right'}`} style={style} src={chainImage} alt={chain.description}/>
    );
};
export const StraightChain = ({width = 20, chain}) => {
    let chainImage;
    switch (chain) {
        case CHAIN.CABLE: chainImage = cableStraight; break;
        // case CHAIN.BEAD: chainImage = beadStraight; break;
        case CHAIN.BUTCH: chainImage = butchStraight; break;
    }

    let style = {
        width: width,
        flexShrink: 0,
        height: '15px',
        backgroundSize: '35px',
        backgroundRepeat: 'repeat-x',
        backgroundImage: `url(${chainImage})`,
    };

    return (
        <div className={`customizer-preview__straight-chain ${chain.description.toLowerCase().replace(' ', '-')}`} style={style}>&nbsp;</div>
    );
};

export const PendantChain = ({offset, chain}) => {
    let chainImage;
    switch (chain) {
        case CHAIN.CABLE: chainImage = cablePendant; break;
        // case CHAIN.BEAD: chainImage = beadPendant; break;
        case CHAIN.BUTCH: chainImage = butchPendant; break;
    }

    let style = {
        marginTop: `${-offset}px`
    };

    return (
        <img className={`customizer-preview__pendant-chain ${chain.description.toLowerCase().replace(' ', '-')}`} style={style} src={chainImage} alt={chain.description}/>
    );
};

export const Loop = () => {
    let style = {
        width: '22px',
    };

    return (
        <img style={style} className="customizer-preview__loop" src={loop} alt="Loop"/>
    )
};
